var exports = {
  "K": "EditFavoriteMemeModal.module__formContainer___QWFCNn",
};

module.exports = exports;
